import PropTypes from 'prop-types';
import { UserProps, UserPropsTypes } from './User';

export const RankingProps = {
  Id: '_id',
  Name: 'name',
  Owner: 'owner',
  IsOwner: 'isOwner',
  IsPartnerGroup: 'isPartnerGroup',
  Participants: 'participants',
  CreatedAt: 'createdAt',
};

export const ParticipantProps = { ...UserProps };

export const RankingPropsTypes = {
  [RankingProps.Id]: PropTypes.string,
  [RankingProps.Name]: PropTypes.string,
  [RankingProps.Owner]: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(UserPropsTypes),
  ]),
  [RankingProps.IsOwner]: PropTypes.bool,
  [RankingProps.IsPartnerGroup]: PropTypes.bool,
  [RankingProps.Participants]: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.shape(UserPropsTypes)])
  ),
  [RankingProps.CreatedAt]: PropTypes.string,
};
